import { HttpClient, queryString } from '@opallabs/api'
import loadStatus from '../loadStatus'

const fetchStatus = (params) => {
  const url = new URL(
    `/api/v1/workspaces/${params.workspaceId}/status`,
    window.location.origin
  )
  url.search = queryString(params)
  return HttpClient().get(url.toString())
}

const getStatus = () => async (dispatch) => {
  // this is necessary to ensure we only add the
  // workspace id to requests that originate from
  // a brand.
  const params = {}
  const OpalMoments = window.OpalMoments
  if (!OpalMoments) {
    return
  }
  const brand = OpalMoments.State.current_brand
  if (!brand) {
    return
  }

  params.workspaceId = brand.id
  params.includeUnscheduled = 'true'

  fetchStatus(params)
    .then((response) => dispatch(loadStatus({ status: response.data.meta })))
    .catch((err) => {
      console.log(err)
      throw err
    })
}

export default getStatus
